import { permissionsSelector } from '@air/redux-permissions';

import { useAirSelector } from '~/utils/ReduxUtils';

export type UseShortUrlPermissionsParams = {
  shortId: string | undefined;
};

export const useShortUrlPermissions = ({ shortId }: UseShortUrlPermissionsParams) => {
  const shortUrlPermissions = useAirSelector((st) => permissionsSelector(st, 'shortIds', shortId));

  return {
    shortUrlPermissions,
  };
};
